<div #scrollTarget></div>

<div class="container-fluid mt-4">
  <h4 class="mb-3">
    <i class="fi fi-rr-users"></i> Team
  </h4>

  <div class="row mb-3 align-items-end">
    
    <div class="col-md-4">
      <input
        type="text"
        [(ngModel)]="search"
        class="form-control"
        placeholder="ძიება..."
        (ngModelChange)="onSearchChange()" />
    </div>
    
    <div class="col-md-2">
      <button class="btn btn-primary w-100" (click)="openCreate()">
        დამატება
      </button>
    </div>

    
  </div>

  <app-spinner [loading]="loading" text="იტვირთება..."></app-spinner>

  <div class="alert alert-info" *ngIf="!loading && !items.length">
    ჩანაწერები ვერ მოიძებნა
  </div>

  <div class="table-responsive" *ngIf="items.length">
    <table class="table table-bordered table-hover align-middle">
      <thead>
        <tr>
          <th style="width:55px;">#</th>
          <th style="width:60px;">⇅</th>
          <th style="width:90px;">სურათი</th>
          <th>სახელი</th>
          <th>თანამდებობა</th>
          <th style="width:150px;">ქმედებები</th>
        </tr>
      </thead>

      <!-- IMPORTANT: cdkDropList tbody-ზე -->
      <tbody
        cdkDropList
        [cdkDropListData]="items"
        (cdkDropListDropped)="drop($event)">

        <tr *ngFor="let item of items; let i = index" cdkDrag>
          <td>{{ i + 1 }}</td>

          <!-- Drag handle -->
          <td class="text-center" style="cursor: grab;">
            <span cdkDragHandle title="გადმოათრიე სორტირებისთვის">☰</span>
          </td>

          <td>
            <img *ngIf="item.image?.trim()" [src]="getFullImageUrl(item.image)" class="square-img" />
            
          </td>

          <td class="truncate-text">{{ item.name }}</td>
          <td class="truncate-text">{{ item.work_position }}</td>


          <td>
            <div class="d-flex">

              <a class="btn btn-sm border rounded mx-2" href="https://sca.ge/team/{{item.id}}" target="_blank">
                <i class="fi fi-rr-link-alt"></i>
              </a>

              <button
                class="btn btn-sm border rounded mx-1"
                (click)="toggleVisible(item)"
                [disabled]="togglingId === item.id">

                <span
                  *ngIf="togglingId === item.id"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true">
                </span>

                <ng-container *ngIf="togglingId !== item.id">
                  <i class="fi fi-rs-eye text-success" *ngIf="item.visible == 1"></i>
                  <i class="fi fi-rr-eye-crossed text-danger" *ngIf="item.visible == 0"></i>
                </ng-container>

              </button>

              <button class="btn btn-sm border rounded mx-1" (click)="openEdit(item)">
                <i class="fi fi-rr-pencil"></i>
              </button>

              <button class="btn btn-sm border rounded mx-1" (click)="remove(item)" title="წაშლა">
                <i class="fi fi-rr-trash text-danger"></i>
              </button>
            </div>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>